import _ from "lodash"

export const isSingleSlider = value => _.isNumber(value)

export const isSameValue = (originalValue, updatedValue) => {
  return isSingleSlider(updatedValue)
    ? originalValue[1] === updatedValue
    : originalValue[0] === updatedValue[0] && originalValue[1] === updatedValue[1]
}
